const KeyValueDisplay = (p) => {

    return (
        <div className="KeyValueDisplay">
            <b>{p.label}</b><span>{p.value}</span>
        </div>
    );
};
/*
        <div className="KeyValueDisplay">
            <div className="flex-row">
                <div className="col-18">
                    <b>{p.label}</b>
                </div>
                <div className="col-6">
                    <span>{p.value}</span>
                </div>
            </div>
        </div>
*/
export default KeyValueDisplay;